module.exports = __webpack_public_path__ + "./assets/img_ximen_color@2x__2ccb1fd35840c3ad895f49c29d6cd4c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_ximen_color@2x.jpg
// module id = 621
// module chunks = 12